module.exports = __webpack_public_path__ + "img/spot.e8f2da51.png";